import React from 'react';
import { useContent } from '../contexts/ContentContext';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const { content, t, lang } = useContent();
  const contactInfo = content.contact || { hq: {}, hubs: [] };

  const hqCity = contactInfo.hq.city?.split(' ').pop() || 'Munich';
  const hubs = contactInfo.hubs || [];

  const tuzla = hubs.find((h: any) => h.name === 'Tuzla');
  const sarajevo = hubs.find((h: any) => h.name === 'Sarajevo');
  const banjaLuka = hubs.find((h: any) => h.name.replace(/\s/g, '').toLowerCase().includes('banjaluka'));

  const locations = [
    { city: hqCity, country: contactInfo.hq.country || 'Germany', type: lang === 'en' ? 'HQ & Operations' : 'Sjedište i Operacije' },
    { city: tuzla?.name || 'Tuzla', country: tuzla?.country || 'BiH', type: lang === 'en' ? 'Production Hub' : 'Produkcijski centar' },
    { city: sarajevo?.name || 'Sarajevo', country: sarajevo?.country || 'BiH', type: lang === 'en' ? 'Production Hub' : 'Produkcijski centar' },
    { city: 'Hamburg', country: 'Germany', type: lang === 'en' ? 'Marketing Hub' : 'Marketinški centar' },
    { city: banjaLuka?.name || 'Banja Luka', country: banjaLuka?.country || 'BiH', type: lang === 'en' ? 'Production Hub' : 'Produkcijski centar' }
  ];

  const socialIcons = [
    {
      name: 'LinkedIn',
      url: content.socialLinks?.linkedin || '#',
      icon: <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.238 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg>
    },
    {
      name: 'Facebook',
      url: content.socialLinks?.facebook || '#',
      icon: <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
    },
    {
      name: 'Instagram',
      url: content.socialLinks?.instagram || '#',
      icon: <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
    }
  ];

  return (
    <footer className="bg-[#1a141f] pt-12 pb-6 border-t border-white/5 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-accent/30 to-transparent"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-4 space-y-4">
            <Link to="/"><img src={content.logo} alt="Saltium Games" width="94" height="64" className="h-16 w-auto mb-2" /></Link>
            <div className="space-y-3">
              <h3 className="text-white font-gaming font-bold uppercase tracking-widest text-lg">Saltium Games</h3>
              <p className="text-gray-400 text-sm leading-relaxed max-w-sm font-light">{t('footerText')}</p>
            </div>
            <div className="flex flex-wrap gap-3 pt-2">
              {socialIcons.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-accent hover:border-accent hover:bg-accent/10 transition-all group"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
          <div className="lg:col-span-8">
            <div className="bg-[#30253a]/40 border border-white/5 rounded-2xl p-6 relative">
              <h4 className="text-accent font-gaming font-bold uppercase tracking-[0.3em] text-[10px] mb-6 flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-accent/40"></span>{t('footer_locations')}</h4>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                {locations.map((loc, idx) => (<div key={idx} className="space-y-1 group"><p className="text-white text-xs font-bold uppercase tracking-widest group-hover:text-accent transition-colors">{loc.city}</p><p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">{loc.country}</p><p className="text-[9px] text-gray-500 uppercase font-medium tracking-tight border-t border-white/5 pt-1 mt-1">{loc.type}</p></div>))}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="text-[9px] font-bold uppercase tracking-[0.3em] text-gray-400">© {new Date().getFullYear()} {t('copyrightText')}</div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
            <Link to="/imprint" className="text-[9px] font-bold uppercase tracking-[0.2em] text-gray-400 hover:text-accent">{lang === 'en' ? 'Imprint' : 'Impressum'}</Link>
            <Link to="/privacy-policy" className="text-[9px] font-bold uppercase tracking-[0.2em] text-gray-400 hover:text-accent">{lang === 'en' ? 'Privacy' : 'Datenschutz'}</Link>
            <Link to="/terms-of-service" className="text-[9px] font-bold uppercase tracking-[0.2em] text-gray-400 hover:text-accent">{lang === 'en' ? 'Terms' : 'AGB'}</Link>
            <Link to="/cookies" className="text-[9px] font-bold uppercase tracking-[0.2em] text-gray-400 hover:text-accent">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};